import { jsx as e, Fragment as l, jsxs as c } from "react/jsx-runtime";
import { c as y } from "./clsx-OuTLNxxd.js";
import './Label.css';const h = "320px", g = "600px", a = "1025px", d = "_label_1dehe_32", m = "_hasMobileText_1dehe_39", i = {
  mobile: h,
  "mobile-wide": "480px",
  tablet: g,
  "tablet-wide": "800px",
  desktop: a,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  label: d,
  hasMobileText: m,
  "size-s": "_size-s_1dehe_54",
  "size-m": "_size-m_1dehe_61",
  "size-l": "_size-l_1dehe_67"
}, z = ({
  children: x,
  className: n,
  mobileText: t,
  size: o = "m",
  ...s
}) => /* @__PURE__ */ e(
  "label",
  {
    className: y(i.label, i[`size-${o}`], { [i.hasMobileText]: !!t }, n),
    ...s,
    children: /* @__PURE__ */ e(l, { children: t ? /* @__PURE__ */ c(l, { children: [
      /* @__PURE__ */ e("span", { "data-testid": "mobile-label", children: t }),
      /* @__PURE__ */ e("span", { "data-testid": "label", children: x })
    ] }) : x })
  }
);
export {
  z as L
};
